import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { OUTGOING_SESSION, OUTGOING_SESSION_SUCCESS, OUTGOING_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getOutgoingSession({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/agents/me/transfer/outgoing`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: OUTGOING_SESSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: OUTGOING_SESSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: OUTGOING_SESSION_ERROR, payload: error });
  }
}

export function* watchOutgoingSession() {
  yield takeEvery(OUTGOING_SESSION, getOutgoingSession);
}

function* watchOutgoingSessionSaga() {
  yield all([fork(watchOutgoingSession)]);
}

export default watchOutgoingSessionSaga;
